import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

//logic:
import {handleSearchInput, holdplaceTranslationId} from "./ItemsSelectorModalLogic";

//components:
import VideoCard from "./cards/VideoCard";
import SpeakerCard from "./cards/SpeakerCard";
import TopicCard from "./cards/TopicCard";
import Fade from "@material-ui/core/Fade";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import {CircularProgress} from "@material-ui/core";

export const ItemsSelectorModal = ({
    type = "",
    showModal,
    setShowModal,
    allItems,
    selectedItems,
    handleItemSelected,
}) => {
    const {t} = useTranslation();

    const [filteredItems, setFilteredItems] = useState(null);
    const [debouncer, setDebouncer] = useState();
    const [itemsSelectedState, setItemsSelectedState] = useState([]);
    const [isLoadingClickEvent, setIsLoadingClickEvent] = useState(false);

    const searchInputRef = useRef();

    const itemsList = filteredItems || allItems || [];
    const typeToUpperCase = type?.toUpperCase();

    const handleItemSelectedMiddlewareDebouncer = (selectedItemsOnClick, var2) => {
        setItemsSelectedState(selectedItemsOnClick || []);
        if (debouncer) clearTimeout(debouncer);
        setDebouncer(
            setTimeout(async () => {
                setIsLoadingClickEvent(true);
                await handleItemSelected(selectedItemsOnClick, var2);
                setIsLoadingClickEvent(false);
            }, 1000)
        );
    };

    useEffect(() => {
        setItemsSelectedState(selectedItems || []);
    }, [selectedItems]);

    useEffect(() => {
        if (!showModal) {
            searchInputRef.current.value = "";
            setFilteredItems(null);
        }
    }, [showModal]);

    const renderCard = (item, i) => {
        if (typeToUpperCase === "VIDEOS")
            return (
                <VideoCard
                    key={i}
                    video={item}
                    selectedItems={itemsSelectedState}
                    handleItemSelected={items => handleItemSelectedMiddlewareDebouncer(items, true)}
                />
            );
        else if (typeToUpperCase === "SPEAKERS")
            return (
                <SpeakerCard
                    key={i}
                    speaker={item}
                    selectedItems={itemsSelectedState}
                    handleItemSelected={items => handleItemSelectedMiddlewareDebouncer(items, true)}
                />
            );
        else if (typeToUpperCase === "TOPICS")
            return (
                <TopicCard
                    key={i}
                    topic={item}
                    selectedItems={itemsSelectedState}
                    handleItemSelected={items => handleItemSelectedMiddlewareDebouncer(items, true)}
                />
            );
    };

    return (
        <Fade
            in={showModal}
            mountOnEnter={false}
            unmountOnExit={false}
            timeout={{
                appear: 1000,
                enter: 1000,
                exit: 500,
            }}
        >
            <div className="position-fixed d-flex justify-content-center align-items-center top-0 left-0 h-100vh w-100vw z-index-100">
                <div
                    className="dark_overlay_modal"
                    onClick={() => {
                        setShowModal(false);
                    }}
                />
                <div className="card items_selector_modal_container">
                    {isLoadingClickEvent ? (
                        <div className="spinner_layer">
                            <CircularProgress />
                        </div>
                    ) : null}
                    <button
                        type="button"
                        className="close mt-5 mr-7 ml-auto font-size-base"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setShowModal(false)}
                    >
                        <HighlightOffRoundedIcon fontSize="large" />
                    </button>

                    <div className="d-flex flex-column">
                        <div className="d-flex w-100 border-bottom gutter-b">
                            <input
                                ref={searchInputRef}
                                type="text"
                                className="items_selector_modal_searchbar"
                                placeholder={t(holdplaceTranslationId(type))}
                                onChange={e => handleSearchInput({e, allItems, setFilteredItems})}
                            />
                        </div>

                        <div className="card-body d-flex custom-scroll-area px-5 px-md-8">
                            {itemsList.map((item, i) => renderCard(item, i))}
                        </div>
                    </div>
                </div>
            </div>
        </Fade>
    );
};
